import { __assign } from '../node_modules/tslib/tslib.es6.js';

var greys = {
    light: {
        1: "#7A7B7D",
        2: "#C9CACD",
        3: "#DBDCDF",
        4: "#F5F6FA",
        5: "#E3E4E8",
        6: "#ECEDF1",
        7: "#E3E4E8",
        8: "#EFF0F4",
        9: "#101010",
        10: "#A6A7AA",
    },
    dark: {
        1: "#727274",
        2: "#464647",
        3: "#353536",
        4: "#1A1A1B",
        5: "#2C2C2D",
        6: "#232324",
        7: "#2C2C2D",
        8: "#202021",
        9: "#000000",
        10: "#585859",
    },
};
var label = {
    green: "#00D372",
    green500: "#009966",
    green400: "#00C363",
    blue: "#00B0F1",
    blue500: "#0069A0",
    blue400: "#0084BE",
    violet: "#8D59FF",
    violet500: "#592ACB",
    violet400: "#7542E2",
    pink: "#FF298A",
    pink500: "#C60084",
    pink400: "#E31587",
    red: "#FF4F5E",
    red500: "#C50042",
    red400: "#E22850",
    orange: "#FFA136",
    orange500: "#E25920",
    orange400: "#FF7139",
    yellow: "#EED55B",
    yellow500: "#B59B15",
    yellow400: "#DEC54B",
};
var colors = {
    modes: {
        light: {
            textPrimary: "#000000",
            inverseTextPrimary: "#FFFFFF",
            background: greys.light[8],
            base: "#FFFFFF",
            toastBackground: "rgba(255, 255, 255, 0.7)",
            popoverBackground: "#FFFFFF",
            modalBackground: "#FFFFFF",
            modalOverlayBackground: greys.light[4],
            grey: greys.light,
            label: Object.entries(label).reduce(function (accumulator, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return (__assign(__assign({}, accumulator), (_b = {}, _b[key] = "".concat(value, "40"), _b)));
            }, {}),
        },
        dark: {
            textPrimary: "#FFFFFF",
            inverseTextPrimary: "#000000",
            background: greys.dark[8],
            base: "#000000",
            toastBackground: "rgba(44, 44, 45, 0.7)",
            popoverBackground: greys.dark[4],
            modalBackground: greys.dark[4],
            modalOverlayBackground: "#000000",
            grey: greys.dark,
            label: Object.entries(label).reduce(function (accumulator, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return (__assign(__assign({}, accumulator), (_b = {}, _b[key] = "".concat(value, "4D"), _b)));
            }, {}),
        },
    },
    brand: "#00D672",
    green: {
        600: "#005E5D",
        500: "#009966",
        400: "#00C663",
        300: "#00D672",
        200: "#58EA92",
        100: "#B5FFD2",
    },
    blue: {
        600: "#004588",
        500: "#0069A0",
        400: "#0084BE",
        300: "#00B0F1",
        200: "#80E8FF",
        100: "#AAF2FF",
    },
    violet: {
        600: "#46278E",
        500: "#592ACB",
        400: "#7542E2",
        300: "#9059FF",
        200: "#C689FF",
        100: "#E3DCFF",
    },
    red: {
        600: "#810220",
        500: "#C50042",
        400: "#E22850",
        300: "#FF4F5E",
        200: "#FF9AA2",
        100: "#FFE1E1",
    },
    pink: {
        600: "#7F165B",
        500: "#C60084",
        400: "#E31587",
        300: "#FF298A",
        200: "#FF8AC5",
        100: "#FFD9F0",
    },
    yellow: {
        600: "#816500",
        500: "#B59B15",
        400: "#DEC54B",
        300: "#EED55B",
        200: "#F9F987",
        100: "#FFFCB7",
    },
    orange: {
        600: "#9E280B",
        500: "#E25920",
        400: "#FF7139",
        300: "#FFA436",
        200: "#FFD5B2",
        100: "#FFF4DE",
    },
    alert: {
        green: "#00D672",
        orange: "#FFA436",
        red: "#FF4F5E",
    },
    satispay: {
        300: "#F94C43",
        400: "#EA3D34",
    },
};
var colorSchemes = [
    "green",
    "blue",
    "violet",
    "red",
    "pink",
    "yellow",
    "orange",
];

export { colorSchemes, colors as default };
//# sourceMappingURL=colors.js.map
